import { sprintf } from 'sprintf-js';

import type { ApiFilestackImageData } from 'api/types/ApiFilestackImageData';
import { FilestackImage } from 'components/FilestackImage/FilestackImage';

import { OrgLogoLink } from './ListingViewSidebarImage.styled';

type Props = {
  orgLogo: ApiFilestackImageData | null;
  orgName: string | null;
  orgURLForCurrentLocale: string | null;
};

export function ListingViewSidebarImage({
  orgLogo,
  orgName,
  orgURLForCurrentLocale,
}: Props) {
  const imageElement = (
    <FilestackImage
      data-qa-id="org-logo"
      width={180}
      height={128}
      data={orgLogo}
      alt={sprintf(getText('Logo of %(orgName)s'), { orgName })}
      objectPosition="left"
      noCrop
    />
  );

  return (
    orgLogo && (
      // eslint-disable-next-line react/jsx-no-useless-fragment
      <>
        {orgURLForCurrentLocale ? (
          <OrgLogoLink to={`${orgURLForCurrentLocale}`}>
            {imageElement}
          </OrgLogoLink>
        ) : (
          imageElement
        )}
      </>
    )
  );
}
